import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Append a timestamp as a query parameter to make the request unique
    const clonedRequest = req.clone({
      params: req.params.set('timestamp', new Date().getTime().toString())
    });

    return next.handle(clonedRequest);
  }
}